import type { OrderLineItem, Resolution, Shop } from "../types";

export function getAvailableResolutions(
  shop: Shop,
  lineItem: OrderLineItem,
): Resolution[] {
  const available: Resolution[] = ["refund"];

  const shopAny = shop as any;

  if (shopAny.exchange?.activated && shopAny.exchange?.available) {
    available.push("exchange");
  }

  if (shopAny.discount?.activated && shopAny.discount?.available) {
    available.push("discount");
  }

  if (
    shopAny.exchange?.activated &&
    shopAny.exchange?.available &&
    shopAny.exchange?.exchangeWithOtherArticles
  ) {
    available.push("exchange-credit");
  }

  const lineItemAny = lineItem as any;
  const nonReturnable: string[] =
    shopAny.preferences?.nonReturnableItems ?? [];

  if (nonReturnable.includes(lineItemAny.product_id)) {
    return [];
  }

  return available;
}
